import { render, staticRenderFns } from "./DraggableNode.vue?vue&type=template&id=fc4ce19a&scoped=true"
import script from "./DraggableNode.vue?vue&type=script&lang=js"
export * from "./DraggableNode.vue?vue&type=script&lang=js"
import style0 from "./DraggableNode.vue?vue&type=style&index=0&id=fc4ce19a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4ce19a",
  null
  
)

export default component.exports